<div
  class="mobi-ui-card-silent webform-box is-row !items-start mobi-ui-ink-grey"
  [class.has-buttons]="buttons"
>
  @if (icon) {
    <mobi-ui-icon-major
      class="mobi-ui-ink-default"
      class="!pt-[5px]"
      [style.color]="iconRed ? '#da2323' : 'var(--mobi-ui-common-shade-text)'"
      [name]="icon"
    />
  }
  <div class="content pt-[5px] flex-1 mobi-ui-ink-default">
    <ng-container *ngTemplateOutlet="content" />
  </div>

  @if (buttons) {
    <div class="buttons">
      <ng-container *ngTemplateOutlet="buttons" />
    </div>
  }
</div>
